<template>
    <div v-if="community" :style="`width: ${100/communitiesAmount}%`" class="project-filter__community">
        <div class="community-row">
            <!-- <v-img v-if="community.is_locked" class="community__identifier" :src="require('@/assets/img/icons/lock.svg')"></v-img> -->
            <v-img class="community__identifier" :src="require('@/assets/img/oval-oval-oval-mask.svg')"></v-img>
            <h4 class="community__name"
                :class="{'community__name--temporary': is_temporary}"
            >{{community.label}}</h4>
        </div>
        <div v-if="community.query" class="community-row">
            <p class="community__query">{{ community.query}}</p>
        </div>
        <ProjectFiltersCommunityMenu
                :community="community"
                :project="project"
                :is_temporary="is_temporary"
        ></ProjectFiltersCommunityMenu>
    </div>
</template>

<script>
    import ProjectFiltersCommunityMenu from "./ProjectFiltersCommunityMenu";

    export default {
        name: "ProjectFiltersCommunityItem",
        components: {ProjectFiltersCommunityMenu},
        props: ['community', 'project', 'communitiesAmount', 'is_temporary'],
        data: () => ({
            query: null,
            VEJson: null
        }),
        methods: {
        },
    }
</script>

<style scoped>

</style>
